import Plans from "../../shared/choose-plan/plans"

import withPresets from "./with-presets"

export default withPresets(Plans)
